import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './HomePage.scss';
import {
  FaTelegram, FaInstagram,
  FaEnvelope,
  FaSun,
  FaMoon,
  FaUser,
  FaBars,
  FaTimes,
  FaYoutube,
  FaPodcast,
  FaChevronDown 
} from 'react-icons/fa';

import {
  HiOutlineArrowLeft,
  HiOutlineDocumentText,
  HiOutlineSupport,
  HiOutlineInformationCircle,
  HiOutlineCurrencyDollar,
  HiOutlinePhone,
  HiOutlineBadgeCheck,
  HiOutlineUsers,
  HiOutlineUserGroup
} from 'react-icons/hi';
import SwiperImg from '../swiper-img';
import { mapPlanIdToPriceKey, NEW_PRICING_BASE_PRICES } from '../../constants';
import { CircularProgress, Modal, Box, Typography, Button, Alert } from '@mui/material'; 
import QRCode from "react-qr-code"; 

import logoImage_1 from '../../assets/White PNG 1.png';
import logoImage_2 from '../../assets/Black PNG 1.png';
import ReactMarkdown from 'react-markdown';

interface SiteSettings {
  site_title: string;
  site_description: string;
  logos: {
    dark: string;
    light: string;
  };
  telegram_link: string;
  instagram_link: string;
  youtube_link: string;
  castbox_link: string;
  about_us: string;
  email: string;
  site_photos?: { id: number; url: string }[];
  active_users: number;
  registred_users: number;
}

interface ApiPlan {
  id: number;
  title: string;
  plan_option_id: number;
}

interface PlanOption {
  title: string;
  order: number;
}

interface PlanOptionsResponse {
  data: { [key: string]: PlanOption };
}

interface DisplayPlan {
  id: number;
  name: string;
  features: string[];
}

interface HomePageProps {
  isAuthenticated: boolean;
  theme: string;
  toggleTheme: () => void;
}

const HomePage: React.FC<HomePageProps> = ({ isAuthenticated, theme, toggleTheme }) => {
  const navigate = useNavigate();
  const mobileMenuRef = useRef<HTMLDivElement>(null);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [registeredUsers, setRegisteredUsers] = useState<number | null>(null);
  const [activeUsers, setActiveUsers] = useState<number | null>(null);
  const [currentUsername, setCurrentUsername] = useState<string | null>(null);
  const [accountValue, setAccountValue] = useState<string>('');
  const [calculatedPrices, setCalculatedPrices] = useState<{ [key: number]: number | null }>({});
  const [calculatorErrorMessage, setCalculatorErrorMessage] = useState<string | null>(null);

  const [plans, setPlans] = useState<DisplayPlan[]>([]);
  const [loadingPlans, setLoadingPlans] = useState(true);
  const [plansError, setPlansError] = useState<string | null>(null);

  const [siteSettings, setSiteSettings] = useState<SiteSettings | null>(null);
  const [loadingSettings, setLoadingSettings] = useState(true);

  const [openAccordionIndex, setOpenAccordionIndex] = useState<number | null>(0); 

  const [telegramModalOpen, setTelegramModalOpen] = useState(false);
  const [telegramInviteUrl, setTelegramInviteUrl] = useState('');
  const [checkingConnection, setCheckingConnection] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState<{type: 'success' | 'error' | 'info', msg: string} | null>(null);

  const apiFetch = async (url: string, options: RequestInit = {}) => {
    const token = localStorage.getItem('token');
    const isFormData = options.body instanceof FormData;
    const headers: HeadersInit = { ...options.headers };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    if (!isFormData) {
      headers['Content-Type'] = 'application/json';
    }

    const response = await fetch(`https://api.neontradepro.com${url}`, { ...options, headers });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ detail: 'An unknown error occurred' }));
        throw new Error(errorData.detail || 'Network response was not ok');
    }
    return response.json();
  };


  useEffect(() => {
    const fetchSiteSettings = async () => {
      setLoadingSettings(true);
      try {
        const settings = await apiFetch('/settings/site');
        setSiteSettings(settings);
      } catch (error) {
        console.error("Failed to fetch site settings:", error);
      } finally {
        setLoadingSettings(false);
      }
    };

    const fetchPlansAndFeatures = async () => {
        setLoadingPlans(true);
        setPlansError(null);
        try {
            const apiPlans: ApiPlan[] = await apiFetch('/plan/');

            const plansWithFeatures = await Promise.all(
                apiPlans.map(async (plan) => {
                    let features: string[] = [];
                    if (plan.plan_option_id) {
                        try {
                            const options: PlanOptionsResponse = await apiFetch(`/plan/options/${plan.plan_option_id}`);
                            if (options && options.data) {
                                features = Object.values(options.data)
                                    .sort((a, b) => (a.order || 0) - (b.order || 0))
                                    .map(option => option.title);
                            }
                        } catch (e: any) {
                            console.error(`Could not fetch features for plan ${plan.id}:`, e.message);
                        }
                    }
                    return {
                        id: plan.id,
                        name: plan.title,
                        features: features,
                    };
                })
            );
            setPlans(plansWithFeatures);
        } catch (error: any) {
            console.error("Failed to fetch plans:", error);
            setPlansError(`خطا در بارگذاری پلن‌ها: ${error.message}`);
        } finally {
            setLoadingPlans(false);
        }
    };

    const checkTelegramConnection = async () => {
      if (!isAuthenticated) return;
      try {
        const userInfo = await apiFetch('/user/info');
        if (!userInfo.telegram_bot_connected && userInfo.telegram_invite_url) {
          setTelegramInviteUrl(userInfo.telegram_invite_url);
          setTelegramModalOpen(true);
        } else {
          setTelegramModalOpen(false);
        }
      } catch (error) {
        console.error("Failed to fetch user info for telegram check:", error);
      }
    };

    fetchSiteSettings();
    fetchPlansAndFeatures();
    checkTelegramConnection();

 setTimeout(() => {
        setRegisteredUsers(1261);
        setActiveUsers(711);
    }, 1500);

    const storedUsername = localStorage.getItem('username');
    if (storedUsername) {
      setCurrentUsername(storedUsername);
    }
  }, [isAuthenticated]);

  const handleLogin = () => navigate('/login');
  const handleDashboard = () => navigate('/dashboard');
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  const closeMobileMenu = useCallback(() => {
    if (isMobileMenuOpen) setIsMobileMenuOpen(false);
  }, [isMobileMenuOpen]);

  const handleScrollToContact = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('contact-us')?.scrollIntoView({ behavior: 'smooth' });
    closeMobileMenu();
  };

  const handleSupportClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (isAuthenticated) {
      navigate('/dashboard/tickets');
    } else {
      navigate('/login', { state: { from: '/dashboard/tickets' } });
    }
  };


  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMobileMenuOpen]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target as Node)) {
        closeMobileMenu();
      }
    };
    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen, closeMobileMenu]);


  const renderAnimatedHeading = (text: string) => {
    return text.split(' ').map((word, index) => (
      <span key={index} className="word-wrapper">
        {word.split('').map((char, charIndex) => (
          <span key={`${index}-${charIndex}`} className="char-wrapper">
            {char}
          </span>
        ))}
      </span>
    ));
  };

  const calculatePriceForPlanInternal = useCallback((planKey: string, account: number): number | null => {
    if (!planKey || isNaN(account) || account < 0) return null;
    const basePrice = NEW_PRICING_BASE_PRICES[planKey];
    if (basePrice === undefined) return null;
    const coefficients: { [key: string]: number } = { 'a': 0.0003, 'b': 0.0005, 'c': 0.0007 };
    const coefficient = coefficients[planKey];
    if (coefficient === undefined) return null;
    const rawCalculatedPrice = (account * coefficient) + basePrice;
    return Math.round(rawCalculatedPrice);
  }, []);

  const handleAccountValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setAccountValue(value);
    if (Object.keys(calculatedPrices).length > 0) setCalculatedPrices({});
    if (calculatorErrorMessage) setCalculatorErrorMessage(null);
  };

  const handleCalculatePrices = () => {
    setCalculatorErrorMessage(null); 
    const accountNum = parseFloat(accountValue);

    if (accountValue.trim() === '') {
      setCalculatedPrices({});
      setCalculatorErrorMessage('لطفاً مقداری را وارد کنید.');
      return;
    }

    if (isNaN(accountNum) || accountNum < 0) {
      setCalculatedPrices({});
      setCalculatorErrorMessage('لطفاً یک عدد معتبر و مثبت وارد کنید.');
      return;
    }

    const newCalculatedPrices: { [key: number]: number | null } = {};
    plans.forEach(plan => {
      const planKey = mapPlanIdToPriceKey(plan.id);
      if (planKey) {
        newCalculatedPrices[plan.id] = calculatePriceForPlanInternal(planKey, accountNum);
      } else {
        newCalculatedPrices[plan.id] = null;
      }
    });
    setCalculatedPrices(newCalculatedPrices);
  };


  const handleStartPurchase = (planId: number) => {
    if (!isAuthenticated) {
      navigate('/login');
    } else {
      navigate(`/plan-details/${planId}?theme=${theme}&intent=purchase`);
    }
  };

  const handleViewPlanDetails = (planId: number) => {
    navigate(`/plan-details/${planId}?theme=${theme}&intent=details`);
  };

  const toggleAccordion = (index: number) => {
    setOpenAccordionIndex(prevIndex => (prevIndex === index ? null : index));
  };

  const handleCheckConnectionAgain = async () => {
    setCheckingConnection(true);
    setConnectionStatus(null); 
    try {
      const userInfo = await apiFetch('/user/info');
      if (userInfo.telegram_bot_connected) {
        setConnectionStatus({ type: 'success', msg: 'اتصال با موفقیت تأیید شد.' });
        setTimeout(() => {
            setTelegramModalOpen(false);
        }, 5000);
      } else {
        setConnectionStatus({ type: 'error', msg: 'هنوز اتصال به ربات تشخیص داده نشد. لطفاً ربات را Start کنید.' });
      }
    } catch (e) {
      console.error(e);
      setConnectionStatus({ type: 'error', msg: 'خطا در برقراری ارتباط با سرور.' });
    } finally {
      setCheckingConnection(false);
    }
  }

  const introContent = [
    {
      title: "نئون ترید و TMP؛ ذهنی امن‌تر، معاملاتی هوشمندتر",
      content: (
        <>
          <p>
            اگر تجربه معامله در بازارهای مالی را داشته باشید، می‌دانید بزرگ‌ترین دشمن یک تریدر بازار نیست؛ ذهن اوست.
            یک ضرر ناگهانی، چند تصمیم احساسی یا عبور از قوانین مدیریت سرمایه می‌تواند نتیجه ماه‌ها تلاش را در چند دقیقه نابود کند.
          </p>
          <p><strong>چالش‌هایی مانند:</strong></p>
          <ul>
            <li>ورودهای بی‌برنامه و معاملات پشت‌سرهم</li>
            <li>تلاش برای جبران سریع ضرر (Revenge Trading)</li>
            <li>بی‌انضباطی در رعایت پلن معاملاتی</li>
            <li>فشار ذهنی، هیجان‌زدگی یا خستگی</li>
            <li>از دست دادن حساب‌های پراپ یا شخصی</li>
          </ul>
          <p>
            مشکلاتی هستند که تقریباً همه تریدرها با آن مواجه می‌شوند.
            و همین دردها باعث تولد سیستم <strong>TMP – Trading Mind Protector</strong> شد.
          </p>
        </>
      )
    },
    {
      title: "🚀 TMP – Trading Mind Protector چیست؟",
      content: (
        <>
          <p>
            TMP یک سیستم هوشمند نظارتی و مدیریتی است که مانند یک محافظ ذهن معاملاتی در کنار شما قرار می‌گیرد؛
            سیستمی که اجازه نمی‌دهد احساسات یا اشتباهات لحظه‌ای حساب شما را تهدید کنند.
          </p>
          <p>این سیستم ترکیبی از:</p>
          <ul>
            <li>🔹 مدیریت ریسک خودکار ۲۴ ساعته</li>
            <li>🔹 کنترل و پایش لحظه‌ای معاملات</li>
            <li>🔹 تحلیل هوشمند رفتار معاملاتی</li>
            <li>🔹 گزارش‌های دقیق برای رشد</li>
          </ul>
          <p>
            <strong style={{ color: 'var(--primary-color)' }}>🔥 تریدری که پلن مشخص می‌کند، TMP اجرای آن را تضمین می‌کند.</strong>
          </p>
        </>
      )
    },
    {
      title: "🔥 TMP چگونه مشکلات تریدرها را حل می‌کند؟",
      content: (
        <>
          <ol>
            <li>جلوگیری از معاملات احساسی</li>
            <li>اجرای دقیق مدیریت سرمایه</li>
            <li>محافظت مداوم ۲۴/۷</li>
            <li>جلوگیری از خطاهای خطرناک</li>
            <li>تبدیل تریدر به یک فرد منظم</li>
          </ol>
        </>
      )
    }
  ];


  if (loadingSettings || loadingPlans) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    );
  }

  const heroImages = siteSettings?.site_photos
    ?.filter(p => p && p.url)
    .map(p => p.url) || [];


  return (
    <div className={`homepage ${theme}${isMobileMenuOpen ? ' mobile-menu-is-open' : ''}`} dir='rtl'>
      <Modal
        open={telegramModalOpen}
        onClose={() => setTelegramModalOpen(false)}
        aria-labelledby="telegram-modal-title"
        aria-describedby="telegram-modal-description"
      >
        <Box className="telegram-modal-box" sx={{
            bgcolor: theme === 'dark' ? '#222' : '#fff',
            color: theme === 'dark' ? '#fff' : '#000',
        }}>
          <Typography id="telegram-modal-title" variant="h6" component="h2" sx={{ mb: 2, textAlign: 'center', fontWeight: 'bold' }}>
            اتصال به ربات تلگرام
          </Typography>
          <Typography id="telegram-modal-description" sx={{ mb: 3, textAlign: 'center', fontSize: '0.95rem', opacity: 0.9 }}>
            برای تکمیل ثبت نام و فعال‌سازی حساب، لطفاً ربات تلگرام را استارت کنید.
          </Typography>

          <div style={{ background: '#fff', padding: '10px', borderRadius: '8px', margin: '0 auto 20px auto', width: 'fit-content' }}>
            {telegramInviteUrl && (
                <QRCode
                size={180}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                value={telegramInviteUrl}
                viewBox={`0 0 180 180`}
                />
            )}
          </div>

          {connectionStatus && (
              <Alert severity={connectionStatus.type} sx={{ mb: 2, width: '100%' }}>
                  {connectionStatus.msg}
              </Alert>
          )}

          <Button
            variant="contained"
            color="primary"
            href={telegramInviteUrl}
            target="_blank"
            fullWidth
            startIcon={<FaTelegram className='mx-2'/>}
            sx={{ mb: 2, fontFamily: 'inherit' }}
          >
            ورود به ربات و استارت
          </Button>
          
          <Button
             variant="outlined"
             onClick={handleCheckConnectionAgain}
             disabled={checkingConnection}
             fullWidth
             sx={{ mb: 1, fontFamily: 'inherit' }}
          >
            {checkingConnection ? 'در حال بررسی...' : 'ربات را استارت کردم (بررسی مجدد)'}
          </Button>

           <Button
             onClick={() => setTelegramModalOpen(false)}
             fullWidth
             sx={{ color: 'var(--text-muted-color)', fontFamily: 'inherit', fontSize: '0.8rem' }}
          >
            بعداً انجام میدهم
          </Button>
        </Box>
      </Modal>

      <header className='header'>
        <nav className='nav-container'>
          <div className='logo'>
            <Link to={`/?theme=${theme}`} onClick={closeMobileMenu}>
              <img src={theme === 'dark' ? logoImage_1 : logoImage_2} alt='لوگوی نئون' />
            </Link>
          </div>
          <div className='nav-links-desktop'>
            <Link className='underline-hover relative' to={`/prediction?theme=${theme}`}>
              پیش‌بینی
            </Link>
            <Link className='underline-hover relative' to={`/rules?theme=${theme}`}>
              قوانین
            </Link>
            <Link className='underline-hover relative' to={`/faq?theme=${theme}`}>
              سوالات متداول
            </Link>
            <Link className='underline-hover relative'
                  to={`/dashboard?theme=${theme}`}
                  state={{ fromInvite: true, tab: 3 }}
                  onClick={closeMobileMenu}>
              دعوت از دوستان
            </Link>
            <a href="#contact-us" className='underline-hover relative' onClick={handleScrollToContact}>
              تماس با ما
            </a>
          </div>
          <div className='header-actions'>
            {!isAuthenticated ? (
              <button className='login-btn header-action-item' onClick={handleLogin}>
                ورود / ثبت نام
              </button>
            ) : (
              <button
                className='user-info-btn header-action-item'
                onClick={handleDashboard}
                aria-label='داشبورد'
              >
                <FaUser className="user-icon" />
                {currentUsername && <span className="username-display">{currentUsername}</span>}
              </button>
            )}
            <button className='theme-toggle-btn header-action-item' onClick={toggleTheme} aria-label='تغییر تم'>
              {theme === 'dark' ? <FaSun /> : <FaMoon />}
            </button>
            <button
              className='hamburger-btn header-action-item'
              onClick={toggleMobileMenu}
              aria-label='باز/بسته کردن منو'
              aria-expanded={isMobileMenuOpen}
              aria-controls='mobile-menu-panel'
            >
              {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </nav>
      </header>
      <div
        ref={mobileMenuRef}
        className={`mobile-menu-panel ${isMobileMenuOpen ? 'is-open' : ''}`}
        id='mobile-menu-panel'
      >
        <Link className='mobile-nav-link' to={`/prediction?theme=${theme}`} onClick={closeMobileMenu}>
          پیش‌بینی
        </Link>
        <Link className='mobile-nav-link' to={`/rules?theme=${theme}`} onClick={closeMobileMenu}> قوانین </Link>
        <Link className='mobile-nav-link' to={`/faq?theme=${theme}`} onClick={closeMobileMenu}>
          سوالات متداول
        </Link>
        <Link className='mobile-nav-link'
              to={`/dashboard?theme=${theme}`}
              state={{ fromInvite: true, tab: 3 }}
              onClick={closeMobileMenu}>
          دعوت از دوستان
        </Link>
        <a href="#contact-us" className='mobile-nav-link' onClick={handleScrollToContact}>
          تماس با ما
        </a>
      </div>

       <section className='hero-section'>
        <div className='hero-content'>
          <h2 className="animated-heading">{renderAnimatedHeading('Never Experience Only Negativity')}</h2>
          <h3 id='title'>{siteSettings?.site_title || ''}</h3>
           {/* <h3 id='title'>{siteSettings.site_title}</h3> */}

          <p className='hero-description'>
            <div className="markdown-body" data-theme={theme==="dark"?"dark":"light"}>
              <ReactMarkdown>
                {siteSettings?.site_description}
              </ReactMarkdown>
            </div>
          </p>
          <div className='cta-buttons'>
            <button className='primary-btn' onClick={isAuthenticated ? handleDashboard : handleLogin}>
              {isAuthenticated ? 'ورود به پنل' : 'شروع کنید'}
            </button>
          </div>
        </div>
        <div className='hero-image'>
          <SwiperImg images={heroImages} />
        </div>
      </section>
      <section className='stats-section'>
        <div className='stats-grid'>
          <div className='stat-item'>
            <HiOutlineUserGroup className='stat-icon' />
            <h3>{siteSettings?.registred_users != null ? siteSettings.registred_users.toLocaleString('fa-IR') : '---'}</h3>
            <p>کاربر ثبت نام شده</p>
          </div>
          <div className='stat-item'>
            <HiOutlineUsers className='stat-icon' />
            <h3>{siteSettings?.active_users != null ? siteSettings.active_users.toLocaleString('fa-IR') : '---'}</h3>
            <p>کاربر فعال</p>
          </div>
        </div>
      </section>

      <section className="intruduce-section-homepage">
        {introContent.map((item, index) => (
          <div 
            key={index} 
            className={`tmp-info-block ${openAccordionIndex === index ? 'open' : ''}`}
            onClick={() => toggleAccordion(index)}
          >
            <div className="accordion-header">
              <h3>{item.title}</h3>
              <FaChevronDown className="accordion-icon" />
            </div>
            <div className="accordion-content">
              <div className="content-inner">
                {item.content}
              </div>
            </div>
          </div>
        ))}
      </section>


      <section className="price-calculator-section-homepage">
        <h2 style={{ textAlign: 'center', marginBottom: '1.5rem', fontSize:'var(--font-size-h2-desktop)'}}>
          محاسبه آنلاین قیمت پلن‌ها
        </h2>
        <p style={{textAlign: 'center', marginBottom: '2rem', fontSize: 'var(--font-size-p-desktop)', color: 'var(--text-muted-color)'}}>
          برای مشاهده قیمت هر پلن متناسب با سرمایه خود، ابتدا مقدار حساب‌تان را وارد کنید.
        </p>
        <div className='calculator-input-area'>
          <label htmlFor="account-value-input" className="sr-only">مقدار حساب شما (دلار):</label>
          <input
            type="number"
            id="account-value-input"
            value={accountValue}
            onChange={handleAccountValueChange}
            placeholder="مثلاً 8000"
            className="account-input"
          />
          <button onClick={handleCalculatePrices} className="calculate-btn">
            محاسبه
          </button>
        </div>
        {calculatorErrorMessage && (
          <div className="calculator-error-message">
            {calculatorErrorMessage}
          </div>
        )}
      </section>

      <section className='plan-section'>
        <h2>پلن‌های ما</h2>
        {loadingPlans && (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
                <CircularProgress />
            </div>
        )}
        {plansError && (
            <div style={{ color: 'red', textAlign: 'center', padding: '20px' }}>
                {plansError}
            </div>
        )}
        {!loadingPlans && !plansError && (
          <div className='plan-grid'>
            {plans.map((plan, index) => {
              let featuresToDisplay = plan.features;
              if (index > 0) {
                const previousPlanFeatures = new Set(plans[index - 1].features);
                featuresToDisplay = plan.features.filter(feature => !previousPlanFeatures.has(feature));
              }

              const planKey = mapPlanIdToPriceKey(plan.id);
              const initialBasePrice = planKey ? NEW_PRICING_BASE_PRICES[planKey] : null;
              const displayPrice = (calculatedPrices[plan.id] !== undefined && calculatedPrices[plan.id] !== null)
                ? calculatedPrices[plan.id]
                : initialBasePrice;

              return (
                <div className='plan-card' key={plan.id}>
                  <div className='plan-card-inner-content'>
                    <h3 style={{textAlign: 'right'}}>{plan.name}</h3>
                    <div className='plan-price-display'>
                      {displayPrice !== null ? (
                          <>
                            <span className='price-currency'>$</span>
                            <span className='price-amount'>{displayPrice.toLocaleString('en-US')}</span>
                            <span className='price-period'> / پایه ماهانه</span>
                          </>
                        ) : (
                        <span className='price-placeholder'>قیمت پایه نامشخص</span>
                      )}
                    </div>
                    <ul>
                        {index === 1 && plans[0] && (
                          <li className='plus-separator'>
                            <span>تمام ویژگی‌های پلن "{plans[0].name}"</span>
                            <span className='plus-icon'>+</span>
                          </li>
                        )}

                        {index === 2 && plans[0] && plans[1] && (
                          <li className='plus-separator'>
                            <span>تمام ویژگی‌های پلن‌های "{plans[0].name}" و "{plans[1].name}"</span>
                            <span className='plus-icon'>+</span>
                          </li>
                        )}

                        {featuresToDisplay.map((feature, featureIndex) => (
                          <li key={`${plan.id}-${featureIndex}`}>
                            <HiOutlineBadgeCheck /> {feature}
                          </li>
                        ))}
                    </ul>
                    <div className="plan-card-actions">
                      <button
                          onClick={() => handleStartPurchase(plan.id)}
                          className='select-plan-btn buy-btn'
                      >
                          شروع خرید
                      </button>
                      <button
                        onClick={() => handleViewPlanDetails(plan.id)}
                        className='select-plan-btn details-btn'>
                        مشاهده جزئیات
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>

      <section className='contact-section' id='contact-us'>
        <div className='contact-content'>
          <h2>ارتباط با ما</h2>
          <div className='contact-grid'>
            <div className='contact-card'>
              <h3>ایمیل</h3>
              <p>{siteSettings?.email}</p>
              <button className='contact-btn' onClick={() => window.location.href = `mailto:${siteSettings?.email}`}>
                <FaEnvelope className='contact-icon' />
                <span>ارسال ایمیل</span>
              </button>
            </div>
            <div className='contact-card'>
              <h3>شبکه‌های اجتماعی</h3>

<div className='social-links'>
  <a href={siteSettings?.telegram_link} className='social-link' aria-label='Telegram' target="_blank" rel="noopener noreferrer">
    <FaTelegram className='social-icon' />
  </a>
  <a href={siteSettings?.instagram_link} className='social-link' aria-label='Instagram' target="_blank" rel="noopener noreferrer">
    <FaInstagram className='social-icon' />
  </a>
  <a href={siteSettings?.youtube_link} className='social-link' aria-label='YouTube' target="_blank" rel="noopener noreferrer">
    <FaYoutube className='social-icon' />
  </a>
  <a href={siteSettings?.castbox_link} className='social-link' aria-label='Castbox' target="_blank" rel="noopener noreferrer">
    <FaPodcast className='social-icon' />
  </a>
</div>
            </div>
          </div>
          </div>
        </section>
      <footer className='footer'>

        <div className='footer-content'>
           <div className='newsletter-section'>
          <h3 className='newsletter-title'>عضویت در خبرنامه</h3>
          <div className='newsletter-form'>
            <input type='email' placeholder='آدرس ایمیل خود را وارد کنید' />
            <button type='submit'>
              <HiOutlineArrowLeft /> ارسال
            </button>
          </div>
        </div>

          <div className='footer-column'>
            <h4>اطلاعات</h4>
            <ul>
              <li><Link to={`/about?theme=${theme}`}><HiOutlineInformationCircle /> درباره ما</Link></li>
              <li><Link to={`/data?theme=${theme}`}><HiOutlineDocumentText /> اطلاعات</Link></li>
              <li><Link to={`/pricing?theme=${theme}`}><HiOutlineCurrencyDollar /> قیمت‌ها</Link></li>
              <li><a href="#contact-us" onClick={handleScrollToContact}><HiOutlinePhone /> تماس با ما</a></li>
              <li><a href="/dashboard/tickets" onClick={handleSupportClick}><HiOutlineSupport /> پشتیبانی</a></li>
            </ul>
          </div>
          <div className='footer-column'>
            <h4>نئون</h4>
            <div className='copyright'>
              <p><HiOutlineInformationCircle /> تمامی حقوق محفوظ است © 1404</p>
              <p> ساخته شده با ❤️</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
export default HomePage;